// Role → allowed workflow action keys.
// The SERVER is the source of truth: if a MOC payload includes `allowedActions`
// (array of action keys), that list is used directly. Otherwise we fall back to
// this role map. ADJUST role names / action keys to match the real API.
export const ROLE_ACTIONS = {
  admin: ['submit', 'start_risk', 'start_impl', 'finish_impl', 'ready_close', 'cancel', 'close', 'approve'],
  pilote: ['submit', 'start_risk', 'start_impl', 'finish_impl', 'ready_close', 'cancel', 'close', 'approve'],
  approbateur: ['approve', 'cancel'],
  hse: ['start_risk', 'ready_close'],
  demandeur: ['submit', 'cancel'],
};

export const ROLE_LABELS = {
  admin: 'Administrateur', pilote: 'Pilote MOC', approbateur: 'Approbateur',
  hse: 'HSE', demandeur: 'Demandeur',
};

export function allowedActionKeys(user, moc) {
  if (Array.isArray(moc?.allowedActions)) return moc.allowedActions;
  const role = (user?.role || 'pilote').toLowerCase();
  return ROLE_ACTIONS[role] || ROLE_ACTIONS.pilote;
}

export const canTransition = (user, moc, key) => allowedActionKeys(user, moc).includes(key);

// Map the Apps Script role IDs to our coarse permission roles.
export const API_ROLE_TO_PERM = {
  'ROLE-01': 'pilote', 'ROLE-03': 'hse', 'ROLE-04': 'hse', 'ROLE-09': 'hse',
  'ROLE-05': 'approbateur', 'ROLE-06': 'approbateur', 'ROLE-07': 'approbateur', 'ROLE-08': 'approbateur',
  'ROLE-11': 'admin', 'ROLE-12': 'admin',
};
const RANK = { admin: 4, pilote: 3, approbateur: 2, hse: 1, demandeur: 0 };
export const permRoleFromApiRoles = (roles = []) => {
  const keys = roles.map((r) => API_ROLE_TO_PERM[r.Role_ID || r]).filter(Boolean);
  if (!keys.length) return 'demandeur';
  return keys.sort((a, b) => RANK[b] - RANK[a])[0];
};

// Coarse capability check by role only (for nav / page-level gating).
export const hasCapability = (user, key) => {
  const role = (user?.role || 'pilote').toLowerCase();
  return (ROLE_ACTIONS[role] || ROLE_ACTIONS.pilote).includes(key);
};
